import { render, staticRenderFns } from "./washingVolume.vue?vue&type=template&id=56e0bc56&scoped=true"
import script from "./washingVolume.vue?vue&type=script&lang=js"
export * from "./washingVolume.vue?vue&type=script&lang=js"
import style0 from "./washingVolume.vue?vue&type=style&index=0&id=56e0bc56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e0bc56",
  null
  
)

export default component.exports